export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Student pilots, private pilot candidates, aviation students, aspiring pilots, and private pilots who want organized visual references for foundational aviation knowledge.',
  },
  {
    question: 'What aviation subjects does it cover?',
    answer:
      'The system covers aircraft systems, cockpit instruments, aerodynamics, flight maneuvers, VFR navigation, airspace, aviation weather, flight planning, and essential flight procedures.',
  },
  {
    question: 'Does it include visual cockpit instrument explanations?',
    answer:
      'Yes. The atlas includes annotated flight instrument illustrations, cockpit layout references, analog and digital display comparisons, and educational instrument interpretation examples.',
  },
  {
    question: 'Does it include ready-to-use aviation study resources?',
    answer:
      'Yes. Practice knowledge questions, instrument recognition cards, navigation worksheets, flight planning exercises, oral review scenarios, and study progress trackers are included.',
  },
  {
    question: 'Is this suitable for beginners?',
    answer:
      'Yes. The system is designed for aspiring and student private pilots, including learners developing their foundational aviation knowledge. It also provides organized references for reviewing previously studied subjects.',
  },
  {
    question: 'Does it cover both traditional and modern cockpits?',
    answer:
      'Yes. It includes educational references for traditional analog instruments and selected modern electronic flight displays used in general aviation aircraft.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. PRIVATE PILOT VISUAL ATLAS™ is a 100% digital aviation educational reference system.',
  },
  {
    question: 'Is this an official flight training course or certification?',
    answer:
      'No. It is a visual educational study resource designed to complement formal flight training. It does not provide flight instruction, pilot certification, examination credit, or regulatory approval.',
  },
  {
    question: 'Does it replace a flight instructor or approved aircraft manuals?',
    answer:
      'No. Actual flight operations require appropriate training, current regulations, approved aircraft documentation, and qualified instruction. The atlas is intended for theoretical learning and educational reference.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
]
